<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      fixed-tabs
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem="{ current }">
      <general-error v-if="!!generalError" />
      <organization-request-list :status="current" />
    </template>
  </tab-list>
</template>

<script>
  import OrganizationRequestList from './OrganizationRequestList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { ORG_REQUEST_STATUS_ENUM, ORG_REQUEST_STATUS_SHORT_ENUM } from '@/constants/enums.js'
  import { ORG_REQUEST_STATUSES } from '@/constants/business.js'

  export default {
    components: {
      TabList,
      OrganizationRequestList,
      GeneralError
    },
    props: {
      tab: {
        type: String
      }
    },
    data () {
      return {
        currentTab: this.tab || ORG_REQUEST_STATUSES.INPROCESS
      }
    },
    computed: {
      title () {
        return this.$t('Список запросов на регистрацию организаций')
      },
      tabs () {
        return this.isAdmin
          ? ORG_REQUEST_STATUS_ENUM
          : ORG_REQUEST_STATUS_SHORT_ENUM
      },
      defaultTab () {
        return ORG_REQUEST_STATUSES.INPROCESS
      }
    },
    methods: {
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/organizationRegistrationRequests/${tabValue}`
      }
    }
  }
</script>
